export default "__VITE_ASSET__C3$s3H6f__"